import { connect } from 'react-redux'
import { State } from '../reducers'
import { ColumnSetting as ColumnSettingInner } from '../components/share/column-setting'

const mapStateToProps = (state: State) => {
  return {
    selectedColumns: state.column.setting,
    permission: state.permission,
  }
}

export const ColumnSetting = connect(mapStateToProps)(ColumnSettingInner)
